import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import Image from '../../../Core/Image';
import { Copy } from '../styles';

export const Wrapper = styled.div`
  background-color: ${themeGet('colors.secondary')};
`;

export const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  justify-content: center;

  padding: 50px 0;

  > h1:first-child,
  > h2:first-child,
  > h3:first-child,
  > h4:first-child {
    text-align: center;
    margin-bottom: 40px;
    color: ${themeGet('colors.text_Secondary')};
  }

  &.with-image {
    padding-bottom: 0;
  }

  &.no-image {
    padding-bottom: 70px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    /* padding: 70px 90px; */
  }
  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    padding: 70px 90px;
  }
`;

export const Card = styled.div`
  border-radius: 6px;
  min-height: 100%;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  transition: all 0.3s ease-in-out;

  &:hover {
    /* box-shadow: 10px 10px 40px 0 #c9c9c9; */
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: flex;
    flex-direction: row;
    max-height: 392px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    display: flex;
    flex-direction: column;
    max-height: 100%;
  }
`;

export const StyledImage = styled(Image)`
  width: 100%;
  height: 100%;
  max-height: 180px;

  object-fit: cover;
  object-position: center;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 50%;
    height: auto;
    max-height: 100%;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    max-height: 180px;
    height: 100%;
    width: 100%;
  }
`;

export const Content = styled.div`
  height: 100%;
  background-color: ${themeGet('colors.neutral_1')};
  padding: 35px 25px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  a {
    margin-top: auto;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 50%;
    min-height: 100%;
    height: auto;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: 100%;
    min-height: auto;
    height: 100%;
    flex: 1 1 100%;
  }
`;

export const OptionalImg = styled.img`
  width: 100%;
  margin: 30px auto 0;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-width: 690px;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    max-height: 100%;
    width: 100%;
    max-width: 690px;
  }
`;

export const StyledCopy = styled(Copy)`
  width: 100%;
`;

export const InnerSpan = styled.span`
  line-height: inherit;
  letter-spacing: inherit;
  color: ${themeGet('colors.text-dark')};
  font-weight: ${themeGet('font-weights.semi-bold')};
  padding-bottom: 4px;
  border-bottom: 1px solid ${themeGet('colors.orange')};
  margin-top: auto;

  &:hover,
  &:focus {
    color: ${themeGet('colors.darkest-orange')};
    border-bottom: 1px solid ${themeGet('colors.orange')};
  }
`;
